import { images } from '../constants';

const products = [
    {
        id: 1,
        image: images.product1Gallery1,
        name: "Printed Mug",
        price: 50,
        disprice: 40,
        stock: 20,
        content: "Sip in style with our customizable Printed Mugs—perfect for gifts, office desks, or cozy mornings at home. Crafted for both function and flair, these mugs are designed to showcase your personality with every pour.",
        description: "Our Printed Mugs are made from high-quality ceramic and are designed for everyday use. Whether you're sipping coffee, tea, or hot cocoa, the vivid, long-lasting prints stay vibrant even after repeated washing. Microwave and dishwasher safe, each mug holds 11 oz and is perfect for personalization—ideal for birthdays, branding, or corporate giveaways.",
        category: ["Personal Gifts", "Custom Print"],
        tags: ["mug", "greeting", "business"],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4
        },
        addInfo: [
            { id: 1, title: "Material", content: "Ceramic" },
            { id: 2, title: "Capacity", content: "11 oz" },
            { id: 3, title: "Print Type", content: "Sublimation Print" },
            { id: 4, title: "Care", content: "Microwave & Dishwasher Safe" }
        ],
        comments: [
            {
            id: 1,
            image: images.product1Review1,
            name: "Ayesha Malik",
            date: "March 2, 2025",
            rating: 5,
            content: "Absolutely loved the print quality! Got it as a gift and it was a hit."
            },
            {
            id: 2,
            image: images.product1Review2,
            name: "Daniel Shah",
            date: "March 10, 2025",
            rating: 4.5,
            content: "Great mug—vibrant print and holds heat well. Will order more for my team."
            }
        ]
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: "Custom Keychains",
        price: 50,
        disprice: 40,
        stock: 30,
        content: "Keep your keys stylishly secure with our Custom Keychains—perfect for giveaways, branding, or personal use. Small in size but big on impact, these accessories blend utility with personality.",
        description: "Our Custom Keychains are crafted from durable acrylic or metal and printed with high-quality, fade-resistant ink. Whether you want to showcase your logo, favorite quote, or unique artwork, each keychain is designed to last. Lightweight and compact, they make excellent promotional items or personalized gifts for any occasion.",
        category: ["Personal Gifts", "Custom Print"],
        tags: ["keychain", "business", "diary"],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4
        },
        addInfo: [
            { id: 1, title: "Material", content: "Acrylic / Metal" },
            { id: 2, title: "Shape Options", content: "Round, Square, Custom Cut" },
            { id: 3, title: "Print Type", content: "UV Printed" },
            { id: 4, title: "Usage", content: "Keys, Bags, Gifts" }
        ],
        comments: [
            {
            id: 1,
            image: images.product2Review1,
            name: "Zara Noor",
            date: "March 15, 2025",
            rating: 5,
            content: "Ordered a batch for our event—everyone loved them! Quality exceeded expectations."
            },
            {
            id: 2,
            image: images.product2Review2,
            name: "Omar Siddiqui",
            date: "March 18, 2025",
            rating: 4,
            content: "Good for promotional giveaways. The print was sharp and colors popped nicely."
            }
        ]
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: "Greeting Cards",
        price: 50,
        disprice: 40,
        stock: 25,
        content: "Make every occasion memorable with our beautifully printed Greeting Cards. Whether it's a birthday, thank-you, or holiday message, our cards bring your words to life with elegance and charm.",
        description: "Crafted from premium cardstock, our Greeting Cards are available in a variety of finishes—matte, glossy, or textured. Fully customizable inside and out, they’re perfect for personal, seasonal, or branded messages. Each card includes a matching envelope and can be printed in full color with vibrant, long-lasting ink. Great for both individuals and businesses looking to add a personal touch.",
        category: ["Stationery Items", "Personal Gifts"],
        tags: ["greeting", "envelope", "calendar"],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4
        },
        addInfo: [
            { id: 1, title: "Paper Type", content: "Matte, Glossy, or Textured" },
            { id: 2, title: "Size Options", content: "A6, A5, Folded or Flat" },
            { id: 3, title: "Envelope", content: "Included" },
            { id: 4, title: "Customization", content: "Front, Inside & Back" }
        ],
        comments: [
            {
            id: 1,
            image: images.product3Review1,
            name: "Adeel Khan",
            date: "April 2, 2025",
            rating: 5,
            content: "Absolutely loved the card quality and printing! Great customer service too."
            },
            {
            id: 2,
            image: images.product3Review2,
            name: "Fatima Sheikh",
            date: "April 5, 2025",
            rating: 4.5,
            content: "Used them for wedding thank-you cards—everyone complimented them!"
            }
        ]
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: "Desk Calendar",
        price: 50,
        disprice: 40,
        stock: 15,
        content: "Stay organized in style with our customizable Desk Calendars. Perfect for home or office desks, they help you track your schedule while showcasing your brand or personal photos.",
        description: "Our Desk Calendars are printed on premium-quality paper with a sturdy base for year-round durability. Available in horizontal or vertical formats, you can personalize each month with logos, photos, or quotes. Ideal for corporate giveaways or personal planning, they offer both practicality and aesthetic appeal. Easy to flip and compact in size, they’re perfect companions for workspaces of any kind.",
        category: ["Office Supplies", "Stationery Items"],
        tags: ["calendar", "business", "wall"],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4
        },
        addInfo: [
            { id: 1, title: "Size", content: "8.5 x 5.5 inches" },
            { id: 2, title: "Pages", content: "12 months + cover" },
            { id: 3, title: "Customization", content: "Photos, Branding, Quotes" },
            { id: 4, title: "Binding", content: "Spiral-bound with stand" }
        ],
        comments: [
            {
            id: 1,
            image: images.product4Review1,
            name: "Raza Malik",
            date: "April 15, 2025",
            rating: 5,
            content: "Excellent quality and very useful for work. Loved adding our company branding!"
            },
            {
            id: 2,
            image: images.product4Review2,
            name: "Neha Aslam",
            date: "April 18, 2025",
            rating: 4,
            content: "Nice print quality and great for gifting. Would like more layout options."
            }
        ]
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: "Branded Cap",
        price: 50,
        disprice: 40,
        stock: 18,
        content: "Top off your look with our stylish Branded Caps—perfect for promotions, teams, or everyday wear. Customizable and comfortable, they’re made to make your message stand out.",
        description: "Our Branded Caps are crafted from high-quality cotton or polyester blends, offering breathability and all-day comfort. Each cap features adjustable straps for a universal fit and can be customized with embroidery or printed logos. Ideal for company events, sports teams, or personal fashion, they combine form, function, and brand visibility in one wearable piece.",
        category: ["Personal Gifts", "Custom Print"],
        tags: ["cap", "business", "diary"],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4
        },
        addInfo: [
            { id: 1, title: "Material", content: "Cotton / Polyester" },
            { id: 2, title: "Size", content: "One Size Fits Most (Adjustable)" },
            { id: 3, title: "Print Type", content: "Embroidery / Heat Transfer" },
            { id: 4, title: "Color Options", content: "Black, White, Navy, Red" }
        ],
        comments: [
            {
            id: 1,
            image: images.product5Review1,
            name: "Junaid Farooq",
            date: "May 2, 2025",
            rating: 5,
            content: "We used these for our team—great fit and the embroidery came out sharp!"
            },
            {
            id: 2,
            image: images.product5Review2,
            name: "Areeba Tanveer",
            date: "May 5, 2025",
            rating: 4.5,
            content: "Comfortable and well-made. Custom print looked professional. Will reorder!"
            }
        ]
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: "Wall Clock",
        price: 50,
        disprice: 40,
        stock: 10,
        content: "Add a timeless statement to your space with our elegant Wall Clocks. Both functional and decorative, these clocks are perfect for homes, offices, or gifts.",
        description: "Our Wall Clocks feature precision quartz movement for accurate timekeeping and are available in a variety of materials including wood, acrylic, and metal. With modern and classic designs to choose from, each clock is crafted to enhance your wall décor while running silently in the background. Easy to mount and powered by a single AA battery, these clocks offer both convenience and charm.",
        category: ["Wall Decor", "Personal Gifts"],
        tags: ["clock", "wall", "calendar"],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4
        },
        addInfo: [
            { id: 1, title: "Material", content: "Wood, Acrylic, or Metal" },
            { id: 2, title: "Clock Type", content: "Quartz Movement" },
            { id: 3, title: "Battery", content: "1 AA Battery (not included)" },
            { id: 4, title: "Size Options", content: "10”, 12”, 14” Diameter" }
        ],
        comments: [
            {
            id: 1,
            image: images.product6Review1,
            name: "Sara Qureshi",
            date: "May 20, 2025",
            rating: 5,
            content: "Beautiful design and super quiet! It matches my modern décor perfectly."
            },
            {
            id: 2,
            image: images.product6Review2,
            name: "Hamza Iqbal",
            date: "May 22, 2025",
            rating: 4.5,
            content: "Arrived on time, easy to install, and keeps perfect time. Highly recommended."
            }
        ]
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: "Personal Diary",
        price: 50,
        disprice: 40,
        stock: 20,
        content: "Capture your thoughts, plans, and daily reflections with our elegantly crafted Personal Diaries. Perfect for journaling, note-taking, or gifting.",
        description: "Our Personal Diaries feature high-quality paper, durable binding, and customizable covers to suit every personality. Available in ruled or plain pages, they’re ideal for writers, students, and professionals alike. Choose from leatherette, fabric, or hardcovers, and personalize with names, logos, or quotes for a unique touch. Compact yet spacious, these diaries are great companions for home, office, or travel use.",
        category: ["Stationery Items", "Office Supplies"],
        tags: ["diary", "business", "greeting"],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4
        },
        addInfo: [
            { id: 1, title: "Cover Material", content: "Leatherette, Fabric, Hardcover" },
            { id: 2, title: "Page Type", content: "Ruled or Plain" },
            { id: 3, title: "Size", content: "A5 / A6 / B5" },
            { id: 4, title: "Customization", content: "Name, Logo, Quote" }
        ],
        comments: [
            {
            id: 1,
            image: images.product7Review1,
            name: "Nimra Hussain",
            date: "June 1, 2025",
            rating: 5,
            content: "Perfect gift item! The custom name engraving looked amazing. Paper quality is top-notch."
            },
            {
            id: 2,
            image: images.product7Review2,
            name: "Bilal Ahmad",
            date: "June 3, 2025",
            rating: 4,
            content: "Solid build and very neat pages. I use it for daily journaling and love it."
            }
        ]
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: "Business Card",
        price: 50,
        disprice: 40,
        stock: 100,
        content: "Make a strong first impression with our premium Business Cards. Ideal for professionals, entrepreneurs, and brands looking to stand out.",
        description: "Our Business Cards are printed on high-quality cardstock with options for matte, glossy, or textured finishes. You can fully customize the design, including logo placement, typography, and color scheme. Choose from single or double-sided printing, standard or custom sizes, and add special effects like foil stamping or embossing for an elevated look. These cards are perfect for networking, meetings, and marketing.",
        category: ["Office Supplies", "Custom Print"],
        tags: ["business", "envelope", "card"],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4
        },
        addInfo: [
            { id: 1, title: "Paper Type", content: "300–350 GSM Cardstock" },
            { id: 2, title: "Finish", content: "Matte, Glossy, Textured" },
            { id: 3, title: "Print Options", content: "Single or Double-sided" },
            { id: 4, title: "Extras", content: "Foil, Embossing, Rounded Corners" }
        ],
        comments: [
            {
            id: 1,
            image: images.product8Review1,
            name: "Zara Imran",
            date: "June 10, 2025",
            rating: 5,
            content: "Absolutely love how these turned out—sleek, professional, and great quality."
            },
            {
            id: 2,
            image: images.product8Review2,
            name: "Osman Tariq",
            date: "June 12, 2025",
            rating: 4.5,
            content: "Impressive printing quality. The textured finish gives a premium feel!"
            }
        ]
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: "Custom Envelope",
        price: 50,
        disprice: 40,
        stock: 200,
        content: "Enhance your brand presence or personal touch with our premium Custom Envelopes—ideal for business correspondence, invitations, or direct mail.",
        description: "Our Custom Envelopes are crafted from high-quality paper stock and are fully customizable with your logo, return address, or artwork. Available in multiple sizes and styles including standard, square, and window options. Choose from matte, textured, or glossy finishes to suit your message. Perfect for businesses, weddings, events, or promotional materials.",
        category: ["Stationery Items", "Office Supplies"],
        tags: ["envelope", "greeting", "business"],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4
        },
        addInfo: [
            { id: 1, title: "Paper Type", content: "Premium White, Kraft, Textured" },
            { id: 2, title: "Sizes", content: "DL, C5, C6, Square" },
            { id: 3, title: "Print Options", content: "Front, Back Flap, Full Bleed" },
            { id: 4, title: "Seal Type", content: "Gummed, Peel & Seal, Self-Seal" }
        ],
        comments: [
            {
            id: 1,
            image: images.product9Review1,
            name: "Fahad Raza",
            date: "June 14, 2025",
            rating: 5,
            content: "Professional quality and sharp printing. These envelopes elevated our corporate identity."
            },
            {
            id: 2,
            image: images.product9Review2,
            name: "Hina Sheikh",
            date: "June 15, 2025",
            rating: 4.5,
            content: "Used them for my wedding invites—beautiful print and paper quality!"
            }
        ]
    },
    {
        id: 10,
        image: images.product10Gallery1,
        name: "Printed Mug",
        price: 50,
        disprice: 40,
        stock: 25,
        content: "Sip in style with our customizable Printed Mugs—perfect for gifts, promotions, or daily coffee moments with a personal touch.",
        description: "Our Printed Mugs are made from durable ceramic and feature high-resolution prints that are microwave and dishwasher safe. Available in various styles including classic, magic (heat-sensitive), and color-handle options. You can personalize them with names, logos, photos, or messages. Ideal for birthdays, corporate branding, or event giveaways, these mugs combine practicality with sentiment.",
        category: ["Personal Gifts", "Custom Print"],
        tags: ["mug", "greeting", "calendar"],
        gallery: {
            image1: images.product10Gallery1,
            image2: images.product10Gallery2,
            image3: images.product10Gallery3,
            image4: images.product10Gallery4
        },
        addInfo: [
            { id: 1, title: "Material", content: "High-Quality Ceramic" },
            { id: 2, title: "Capacity", content: "325ml / 11oz" },
            { id: 3, title: "Print Type", content: "Sublimation / UV Print" },
            { id: 4, title: "Care", content: "Microwave & Dishwasher Safe" }
        ],
        comments: [
            {
            id: 1,
            image: images.product10Review1,
            name: "Taha Yousuf",
            date: "June 16, 2025",
            rating: 5,
            content: "Print came out super vibrant and clean. Made a great gift for my colleague!"
            },
            {
            id: 2,
            image: images.product10Review2,
            name: "Sana Khalid",
            date: "June 16, 2025",
            rating: 4.5,
            content: "Loved the color choices and printing quality. Will order again for my team."
            }
        ]
    },
    {
        id: 11,
        image: images.product11Gallery1,
        name: "Custom Keychain",
        price: 50,
        disprice: 40,
        stock: 100,
        content: "Add personality and branding to your everyday carry with our Custom Keychains—ideal for giveaways, gifts, or personal use.",
        description: "Our Custom Keychains are available in a variety of shapes, materials, and finishes including acrylic, metal, leather, and rubber. They can be customized with names, logos, photos, or text using UV print, engraving, or resin coating. Durable and lightweight, these keychains are perfect for promotional campaigns, personal accessories, or memorable keepsakes.",
        category: ["Custom Print", "Personal Gifts"],
        tags: ["keychain", "business", "mug"],
        gallery: {
            image1: images.product11Gallery1,
            image2: images.product11Gallery2,
            image3: images.product11Gallery3,
            image4: images.product11Gallery4
        },
        addInfo: [
            { id: 1, title: "Material Options", content: "Acrylic, Metal, Leather, Rubber" },
            { id: 2, title: "Customization", content: "UV Print, Engraving, Photo Insert" },
            { id: 3, title: "Shapes", content: "Round, Rectangle, Heart, Custom Cut" },
            { id: 4, title: "Attachment", content: "Standard Ring, Clip Hook" }
        ],
        comments: [
            {
            id: 1,
            image: images.product11Review1,
            name: "Aliya Noman",
            date: "June 16, 2025",
            rating: 5,
            content: "Perfect for party favors! The printing was clean and the quality felt premium."
            },
            {
            id: 2,
            image: images.product11Review2,
            name: "Jibran Shah",
            date: "June 17, 2025",
            rating: 4.5,
            content: "Ordered these for our company event. Guests loved the personalized touch."
            }
        ]
    },
    {
        id: 12,
        image: images.product12Gallery1,
        name: "Greeting Notes",
        price: 50,
        disprice: 40,
        stock: 150,
        content: "Celebrate moments and express heartfelt messages with our beautifully designed Greeting Notes—ideal for all occasions.",
        description: "Our Greeting Notes are printed on premium textured or matte cardstock, available in a range of sizes and designs for birthdays, holidays, weddings, thank-yous, and more. Each note can be customized with your message, branding, or illustrations. Options include single-fold, flat, or pop-up designs, with envelopes included. Perfect for personal sentiments or business thank-you cards.",
        category: ["Stationery Items", "Personal Gifts"],
        tags: ["greeting", "envelope", "diary"],
        gallery: {
            image1: images.product12Gallery1,
            image2: images.product12Gallery2,
            image3: images.product12Gallery3,
            image4: images.product12Gallery4
        },
        addInfo: [
            { id: 1, title: "Paper Type", content: "Matte, Textured, Recycled Cardstock" },
            { id: 2, title: "Sizes", content: "A6, A5, Square" },
            { id: 3, title: "Customization", content: "Full Color Print, Personal Messages, Logos" },
            { id: 4, title: "Envelope Included", content: "Yes, Matching or Custom" }
        ],
        comments: [
            {
            id: 1,
            image: images.product12Review1,
            name: "Neha Qureshi",
            date: "June 17, 2025",
            rating: 5,
            content: "Elegant and personal. I used these for my wedding thank-you notes and they were perfect!"
            },
            {
            id: 2,
            image: images.product12Review2,
            name: "Bilal Aftab",
            date: "June 17, 2025",
            rating: 4.5,
            content: "Ordered for my small business—adds a warm touch to every package. Will reorder!"
            }
        ]
    },
    {
        id: 13,
        image: images.product13Gallery1,
        name: "Desk Calendar",
        price: 50,
        disprice: 40,
        stock: 80,
        content: "Stay organized and inspired with our customizable Desk Calendars—perfect for homes, offices, and gifting.",
        description: "Our Desk Calendars are printed on high-quality thick paper with durable binding and sturdy stands. Available in horizontal and vertical formats, each calendar can be personalized with company branding, photos, quotes, or important dates. Choose between monthly, weekly, or yearly views. Ideal for corporate promotions, creative gifts, or personal planning.",
        category: ["Office Supplies", "Stationery Items"],
        tags: ["calendar", "wall", "business"],
        gallery: {
            image1: images.product13Gallery1,
            image2: images.product13Gallery2,
            image3: images.product13Gallery3,
            image4: images.product13Gallery4
        },
        addInfo: [
            { id: 1, title: "Size Options", content: "A5, A6, Custom Sizes" },
            { id: 2, title: "Page Style", content: "Monthly, Weekly, Yearly" },
            { id: 3, title: "Binding", content: "Wire-O, Spiral, Stapled" },
            { id: 4, title: "Customization", content: "Logos, Photos, Special Dates" }
        ],
        comments: [
            {
            id: 1,
            image: images.product13Review1,
            name: "Sadia Iqbal",
            date: "June 17, 2025",
            rating: 5,
            content: "Crisp design and sturdy build. Perfect for my office desk. Loved the custom logo option!"
            },
            {
            id: 2,
            image: images.product13Review2,
            name: "Usman Tariq",
            date: "June 17, 2025",
            rating: 4.5,
            content: "Great quality and delivery. My clients loved them as New Year giveaways."
            }
        ]
    },
    {
        id: 14,
        image: images.product14Gallery1,
        name: "Branded Cap",
        price: 50,
        disprice: 40,
        stock: 120,
        content: "Top off your style or marketing campaign with our premium Branded Caps—customized for events, teams, or everyday wear.",
        description: "Our Branded Caps are made from breathable, durable fabrics like cotton and polyester. Available in snapback, baseball, and trucker styles, each cap features high-quality embroidery or printing of logos, slogans, or artwork. Adjustable closures ensure a comfortable fit for all. Ideal for sports teams, corporate branding, merchandise, or casual fashion.",
        category: ["Custom Print", "Personal Gifts"],
        tags: ["cap", "diary", "business"],
        gallery: {
            image1: images.product14Gallery1,
            image2: images.product14Gallery2,
            image3: images.product14Gallery3,
            image4: images.product14Gallery4
        },
        addInfo: [
            { id: 1, title: "Fabric", content: "Cotton, Polyester, Mesh" },
            { id: 2, title: "Styles", content: "Snapback, Trucker, Baseball" },
            { id: 3, title: "Customization", content: "Embroidery, Heat Transfer, Screen Print" },
            { id: 4, title: "Closure", content: "Adjustable Strap, Snapback" }
        ],
        comments: [
            {
            id: 1,
            image: images.product14Review1,
            name: "Zain Malik",
            date: "June 17, 2025",
            rating: 5,
            content: "The caps turned out amazing! Quality stitching and perfect for our startup event."
            },
            {
            id: 2,
            image: images.product14Review2,
            name: "Mehwish Rana",
            date: "June 17, 2025",
            rating: 4.5,
            content: "Great fit and durable print. My team wears them every day!"
            }
        ]
    },
    {
        id: 15,
        image: images.product15Gallery1,
        name: "Wall Timepiece",
        price: 50,
        disprice: 40,
        stock: 75,
        content: "Enhance your interior with our stylish Wall Timepieces—where functionality meets timeless design.",
        description: "Our Wall Timepieces offer precise timekeeping through high-quality quartz movement and come in a variety of elegant designs—from modern minimalism to vintage charm. Crafted using durable materials like wood, metal, and acrylic, these clocks are silent, battery-operated, and easy to hang. Whether for your living room, office, or kitchen, they bring sophistication to any wall.",
        category: ["Wall Decor", "Personal Gifts"],
        tags: ["wall", "clock", "calendar"],
        gallery: {
            image1: images.product15Gallery1,
            image2: images.product15Gallery2,
            image3: images.product15Gallery3,
            image4: images.product15Gallery4
        },
        addInfo: [
            { id: 1, title: "Materials", content: "Wood, Metal, Acrylic" },
            { id: 2, title: "Movement", content: "Quartz (Silent Sweep)" },
            { id: 3, title: "Mounting", content: "Wall-Hung with Hook Slot" },
            { id: 4, title: "Power", content: "1 AA Battery (not included)" }
        ],
        comments: [
            {
            id: 1,
            image: images.product15Review1,
            name: "Hina Ali",
            date: "June 17, 2025",
            rating: 5,
            content: "Absolutely love the design—adds elegance to my hallway. Keeps perfect time!"
            },
            {
            id: 2,
            image: images.product15Review2,
            name: "Taimoor Khan",
            date: "June 17, 2025",
            rating: 4.5,
            content: "Beautiful and quiet. Matches my modern aesthetic perfectly."
            }
        ]
    }

];

export default products;